import React from 'react';
import { AlertCircle, Save, ArrowLeft, Loader2 } from 'lucide-react';
import { ConfirmationDialogsProps } from './types';

function ConfirmationDialogs({
  showApiTypeDialog,
  pendingApiType,
  currentApiType,
  onConfirmApiTypeChange,
  onCancelApiTypeChange,
  showExitDialog,
  hasUnsavedChanges,
  existingImages,
  isLoading,
  onSaveAndExit,
  onConfirmExit,
  onCancelExit
}: ConfirmationDialogsProps) {
  return (
    <>
      {/* API Type Change Confirmation Dialog */}
      {showApiTypeDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <div className="flex items-center space-x-3 mb-4">
              <AlertCircle className="w-6 h-6 text-amber-500" />
              <h3 className="text-lg font-semibold text-gray-900">Change API Type</h3>
            </div>
            
            <p className="text-gray-600 mb-6">
              Changing API type will clear all current API configuration.
              <br /><br />
              Are you sure you want to change from{' '}
              <strong>{currentApiType === 'cps' ? 'CPS Golf' : 'ChronoGolf'}</strong> to{' '}
              <strong>{pendingApiType === 'cps' ? 'CPS Golf' : 'ChronoGolf'}</strong>?
            </p>
            
            <div className="flex justify-end space-x-3">
              <button
                type="button"
                onClick={onCancelApiTypeChange}
                className="px-4 py-2 text-gray-600 hover:text-gray-800 border border-gray-300 rounded-md hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={onConfirmApiTypeChange}
                className="px-4 py-2 bg-amber-600 text-white rounded-md hover:bg-amber-700"
              >
                Confirm Change
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Exit Confirmation Dialog */}
      {showExitDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <div className="flex items-center space-x-3 mb-4">
              <AlertCircle className="w-6 h-6 text-amber-500" />
              <h3 className="text-lg font-semibold text-gray-900">You have unsaved changes</h3>
            </div>
            
            <div className="mb-6">
              <p className="text-gray-600 mb-4">
                You have unsaved changes that will be lost if you leave this page.
              </p>
              <div className="text-sm text-gray-500 space-y-1">
                <p>Detected changes in:</p>
                <ul className="list-disc list-inside ml-2 space-y-1">
                  <li>Golf course information</li>
                  <li>API configuration</li>
                  {existingImages.length > 0 && <li>Course images</li>}
                </ul>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={onSaveAndExit}
                disabled={isLoading}
                className="flex-1 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50 flex items-center justify-center space-x-2"
              >
                {isLoading ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    <span>Saving...</span>
                  </>
                ) : (
                  <>
                    <Save className="w-4 h-4" />
                    <span>Save and Exit</span>
                  </>
                )}
              </button>
              <button
                type="button"
                onClick={onConfirmExit}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 flex items-center justify-center space-x-2"
              >
                <ArrowLeft className="w-4 h-4" />
                <span>Discard Changes</span>
              </button>
              <button
                type="button"
                onClick={onCancelExit}
                className="flex-1 px-4 py-2 text-gray-600 hover:text-gray-800 border border-gray-300 rounded-md hover:bg-gray-50"
              >
                Continue Editing
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ConfirmationDialogs;